import { getWeek as getWeekBase } from 'date-fns'
import { getLocale } from './getLocale'

export function getWeek(date: Date) {
  return getWeekBase(date, { locale: getLocale(), weekStartsOn: 1 })
}
